import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'
import { ILesson } from '@dtos/Course'

const GET_NEXT_AVAILABLE_LESSON_DATA = gql`
  query NextAvailableLessonData($currentLessonId: ID!, $enrollmentId: ID!) {
    nextAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
      title
      courseContentId
      releaseAt
      releaseAfter
      lockAt
      lockAfter
      createdAt
      description
      activity {
        examQuestionsCount
      }
      media {
        id
        type
        duration
        hostKey
        host
        fileExt
        text
        organizationUuid
      }
      coverImage {
        cdnFileUrl
      }
      extraMedias {
        id
        title
        type
        duration
        fileExt
        text
        hostKey
        host
        organizationUuid
        createdAt
      }
    }
  }
`

export const useGetNextAvailableLessonData = (
  currentLessonId: number,
  enrollmentId: number,
) => {
  const [getNextAvailableLessonData, { loading, error }] = useLazyQuery(
    GET_NEXT_AVAILABLE_LESSON_DATA,
    {
      variables: { currentLessonId, enrollmentId },
    },
  )

  return { getNextAvailableLessonData, loading, error } as {
    getNextAvailableLessonData: (
      currentLessonId: number,
      enrollmentId: number,
    ) => Promise<QueryResult<{ nextAvailableLesson: ILesson }>>
    loading: boolean
    error: ApolloError
  }
}
